module.exports = __webpack_public_path__ + "img/israel.070dc68b.svg";